module.exports = __webpack_public_path__ + "media/3-e.1f32ffde.wav";